export enum ResolvableServiceUsageFormTab {
  ResolvableServiceSelection = 'resolvableServiceSelection',
  ResolvableServiceUsageInfo = 'resolvableServiceUsageInfo',
}
